import APIService from '@/services/APIService.js';

export default {
  getAll() {
    return APIService.apiCall().get('/importadoresDados/getAll');
  },
  getLayouts() {
    return APIService.apiCall().get('/importadoresDados/getLayouts');
  },
  salvar(postData) {
    return APIService.apiCall().post('/importadoresDados/salvar', JSON.stringify(postData));
  },
  deletar(id) {
    return APIService.apiCall().get(`/importadoresDados/excluir/${id}`);
  },
  baixarLogsTecnicos(id) {
    return APIService.apiCall().get(`/importadoresDados/baixarLogs/${id}`, {
      responseType: 'blob',
      timeout: 60 * 60 * 1000
    });
  },
  baixarErros(id) {
    return APIService.apiCall().get(`/importadoresDados/baixarErros/${id}`, {
      responseType: 'blob',
      timeout: 60 * 60 * 1000
    });
  },
  baixarArquivoModelo(layoutSlug) {
    return APIService.apiCall().get(`/importadoresDados/baixarArquivoModelo/${layoutSlug}`, {
      responseType: 'blob',
      timeout: 60 * 60 * 1000
    });
  }
};
